module.exports = __webpack_public_path__ + "static/media/m3sj.16ebd80e.png";